const Include = Symbol('Include');
const Exclude = Symbol('Exclude');
export const Inclusion = {
  Include,
  Exclude,
} as const;
export type Inclusion = (typeof Inclusion)[keyof typeof Inclusion];
